import React from 'react';
interface Props {
  fillColor?: string;
}
function BreastIcon({ fillColor = '#17385D' }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none">
      <g clipPath="url(#clip0_851_3298)">
        <path
          d="M13.1682 2.2052C13.3275 2.01457 13.5744 1.9177 13.8213 1.93957C14.2057 1.9802 14.4994 2.3052 14.4994 2.68957C14.4994 2.87395 14.4307 3.05207 14.3088 3.18957L10.1588 7.8552H8.39942L13.1682 2.2052ZM7.11505 9.3552H7.13692H10.1619C10.5901 9.3552 10.9994 9.17082 11.2838 8.85207L15.4307 4.18645C15.7963 3.77395 15.9994 3.23957 15.9994 2.68957C15.9994 1.53332 15.1213 0.564574 13.9713 0.448949C13.2307 0.373949 12.5026 0.670824 12.0213 1.23957L6.44005 7.8552L6.42755 7.87082L6.25255 8.0802L5.8713 8.53332C5.7463 8.68332 5.71817 8.88957 5.79942 9.0677C5.88067 9.24582 6.0588 9.35832 6.25255 9.35832H6.8463H7.1213L7.11505 9.3552ZM5.1463 10.5021L0.1463 15.5021C0.00254954 15.6458 -0.0380755 15.8614 0.0369245 16.0458C0.111925 16.2302 0.2963 16.3552 0.499425 16.3552C1.06505 16.3552 3.12755 16.0927 5.0588 15.3208C6.95255 14.5614 8.99942 13.1958 8.99942 10.8552V10.3552H8.49942H5.49942H5.29317L5.1463 10.5021Z"
          fill={fillColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_851_3298">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0 0.355469)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default BreastIcon;
